// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"01a975f7","453":"eea76131","565":"b07f4b87","756":"6343e536"}[chunkId] + ".chunk.js";
};